module.exports = __webpack_public_path__ + "img/de-flag.2a677061.svg";